import styled from "styled-components";
import Navbar from "../Components/Navbar";
import Announcements from "../Components/Announcements"
import Services from "../Components/Services";
import Newsletter from "../Components/Newsletter";
import Footer from "../Components/Footer";


const Container = styled.div`
`
const Title = styled.h1`
    margin: 20px;
`
const FilterContainer = styled.div`
    display: flex;
    justify-content: space-between;
` 
const Filter = styled.div`
    margin: 25px;
`
const FilterText = styled.span`
    font-size: 20px;
    font-weight: 600;
    margin-right: 20px;
`
const Select = styled.select`
    padding: 5px 10px;
    margin-right: 20px;
    border-style: none;
    background-color: #bff7bfcc;
`
const Option = styled.option`
    color: white;
    background-color: #4c4073;
`

const ProductList = () => {
    return (
        <Container>
            <Navbar />
            <Announcements />
            <Title>Servicios</Title>

            <FilterContainer >
                <Filter >
                    <FilterText > Filter producs: </FilterText>
                    <Select >
                        <Option disabled selected > Select Service </Option>
                        <Option > Upholstery cleaning </Option>
                        <Option > Carpet cleaning </Option>
                        <Option > House cleaning </Option>
                        <Option > Maintenace in general </Option>
                    </Select>
                </Filter>
                <Filter >
                    <FilterText > Sort producs: </FilterText>
                </Filter>
            </FilterContainer>
            <Services />
            <Newsletter />
            <Footer />
        </Container>
    )
}

export default ProductList
